import {onFind} from "@elements/init-modules-in-scope";

const isMobile = () => matchMedia('(max-width: 767px)').matches;
export function init () {
    onFind('.js-is-mobile-input', function (baseElement) {
        baseElement.setAttribute('value', isMobile() ? 1 : 0);
    });
}